<template>
  <div class="layout_contents">
    <!-- Title -->
    <div class="area_title">
      <div class="txt_title">{{ $t('facilityGuide.seatLocation') }}</div>
      <div class="txt_det">{{ $t('facilityGuide.tsushimaIntro') }}</div>
    </div>
    <!-- //Title -->

    <div class="area_contents">
      <!-- Swiper -->
      <swiper
        class="tabs_slider"
        :modules="modules"
        :slidesPerView="'auto'"
        :space-between="12"
        navigation
        @swiper="onSwiper"
        @slideChange="onSlideChange"
      >
        <swiper-slide v-for="(seat, index) in daemadoSeatList" :key="index">
          <a href="javascript:" :class="{ active: currentTab === index }" @click="currentTab = index">
            {{ seat.name[locale] }}
          </a>
        </swiper-slide>
      </swiper>
      <!-- //Swiper -->

      <div>
        <!-- View Seat -->
        <div class="view_seat">
          <!-- info Seat -->
          <div class="info_seat">
            <div class="info_seat_content">
              <div class="data_view">{{ daemadoSeatList[currentTab].category }}</div>
              <div class="name_seat">{{ daemadoSeatList[currentTab].name[locale] }}</div>
              <div class="seat_desc">{{ daemadoSeatList[currentTab].promotionalText[locale] }}</div>
              <div class="seat_desc sub" v-if="daemadoSeatList[currentTab].promotionalSubText">
                {{ daemadoSeatList[currentTab].promotionalSubText[locale] }}
              </div>

              <ul class="list_info">
                <li v-for="item in convertDescription">{{ item }}</li>
              </ul>
            </div>

            <div class="detail_image_list">
              <swiper
                class="tab_menu"
                :modules="modules"
                :slidesPerView="3"
                navigation
                @swiper="onSwiper"
                @slideChange="onSlideChange"
              >
                <swiper-slide
                  v-for="(item, index) in detailsImageBodyList[currentTab]"
                  :key="index"
                  :class="{ active: imageActiveTab[currentTab] === index }"
                >
                  <a href="javascript:" @click="imageActiveTab[currentTab] = index">
                    <img :src="item.url" />
                  </a>
                </swiper-slide>
              </swiper>
            </div>
          </div>
          <!-- //info Seat -->

          <div class="tab_content">
            <img :src="selectedImageUrl" />
          </div>
        </div>
        <!-- //View Seat -->
        <!-- Location -->
        <div class="view_location" v-if="currentLocationImageUrl">
          <div class="label_location">{{ $t('facilityGuide.location') }}</div>
          <div class="local_image">
            <img :src="currentLocationImageUrl" />
          </div>
        </div>
        <!-- //Location -->
      </div>
    </div>
  </div>
</template>

<script>
import { Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/vue';

import 'swiper/css/navigation';
import 'swiper/css';

export default {
  name: 'DaemadoSeat',
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      currentTab: 0,
      imageActiveTab: [],
      daemadoSeatList: [
        {
          name: {
            ko: '프리미엄',
            en: 'Premium',
            ja: 'プレミアム',
          },
          promotionalText: {
            ko: '이코노미석보다 넓고 편안한 리클라이너 시트가 적용된 프리미엄석으로 편안한 여행',
            en: 'Travel comfortably in premium class seats, which are wider than economy class seats and have comfortable recliner seats',
            ja: 'エコノミー座席より広く快適なリクライニングシートが適用されたプレミアム席で快適な旅行',
          },
          description: {
            ko: '우선 하선\n다과 제공\n넓은 좌석\n시설 위치: 2F',
            en: 'Disembark first\nRefreshments provided\nWide seat\nFacility Location : 2F',
            ja: '優先降船\n軽食提供\n広い座席\n施設の位置：2F',
          },
          gradeImages: [
            {
              category: 'details',
              url: require('@/assets/images/information/facility/demado_premium_seat01.png'),
            },
            {
              category: 'details',
              url: require('@/assets/images/information/facility/demado_premium_seat02.png'),
            },
          ],
        },
        {
          name: {
            ko: '이코노미',
            en: 'Economy',
            ja: 'エコノミー',
          },
          promotionalText: {
            ko: '대마도 여행을 위한 실속있는 선택',
            en: 'A practical choice for traveling to Tsushima Island',
            ja: '対馬旅行のためのお得な選択',
          },
          description: {
            ko: '시설 위치: 1F',
            en: 'Facility Location : 1F',
            ja: '施設の位置：1F',
          },
          gradeImages: [
            {
              category: 'details',
              url: require('@/assets/images/information/facility/demado_economy_seat01.png'),
            },
            {
              category: 'details',
              url: require('@/assets/images/information/facility/demado_economy_seat02.png'),
            },
          ],
        },
      ],

      detailsImageBodyList: [],
      locationImageBodyList: [],
    };
  },
  watch: {
    currentTab() {
      this.imageActiveTab[this.currentTab] = 0;
    },
  },
  computed: {
    locale() {
      return this.$i18n.locale;
    },
    selectedImageUrl() {
      return this.detailsImageBodyList[this.currentTab]?.[this.imageActiveTab[this.currentTab]]?.url || '';
    },
    currentLocationImageUrl() {
      return this.locationImageBodyList[this.currentTab]?.url || '';
    },
    convertDescription() {
      return this.daemadoSeatList[this.currentTab].description[this.locale].split('\n');
    },
  },
  methods: {
    showTabContent(imageSrc) {
      this.selectedTabImageSrc = imageSrc;
    },
    getDaemadoSeatList() {
      // TODO: API 연동
      this.detailsImageBodyList = this.daemadoSeatList.map(item =>
        item.gradeImages.filter(image => image.category === 'details'),
      );
      this.locationImageBodyList = this.daemadoSeatList.map(item =>
        item.gradeImages.find(image => image.category === 'location'),
      );

      this.imageActiveTab = Array(this.daemadoSeatList.length).fill(0);
    },
  },
  setup() {
    const onSwiper = () => {};
    const onSlideChange = () => {};
    return {
      onSwiper,
      onSlideChange,
      modules: [Navigation],
    };
  },
  created() {
    this.getDaemadoSeatList();
  },
};
</script>

<style scoped>
.tabs_slider {
  padding: 6px 0;
  margin-bottom: 60px;
}
.tabs_slider .swiper-slide {
  width: auto !important;
  margin-right: 12px;
}
.tabs_slider .swiper-slide a {
  display: inline-block;
  padding: 0 28px;
  border-radius: 100px;
  border: 1px solid #446ceb;
  font-weight: 600;
  color: #446ceb;
  font-size: 20px;
  line-height: 54px;
  background-color: #fff;
}
.tabs_slider .swiper-slide a.active {
  background-color: #446ceb;
  color: #fff;
}
.tabs_slider :deep(.swiper-button-prev),
.tabs_slider :deep(.swiper-button-next) {
  width: 70px;
  height: 62px;
  top: 4px;
  margin: 0;
  background-color: #fff;
}
.tabs_slider :deep(.swiper-button-prev) {
  left: 0;
}
.tabs_slider :deep(.swiper-button-next) {
  right: 0;
}

.tabs_slider :deep(.swiper-button-prev:before),
.tabs_slider :deep(.swiper-button-next:before) {
  position: absolute;
  top: 1px;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-color: #fff;
  box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.2);
  content: '';
  flex: none;
}
.tabs_slider :deep(.swiper-button-prev:before) {
  left: 5px;
}
.tabs_slider :deep(.swiper-button-next:before) {
  right: 5px;
}
.tabs_slider :deep(.swiper-button-prev.swiper-button-disabled),
.tabs_slider :deep(.swiper-button-next.swiper-button-disabled) {
  display: none;
}
.tabs_slider :deep(.swiper-wrapper) {
  height: 56px;
}
.tabs_slider :deep(.swiper-button-prev:after),
.tabs_slider :deep(.swiper-button-next:after) {
  color: #b6bbbf;
  font-weight: bold;
  font-size: 20px;
  z-index: 1;
}
.tabs_slider :deep(.swiper-button-prev:after) {
  margin-left: -2px;
}
.tabs_slider :deep(.swiper-button-next:after) {
  margin-right: -2px;
}
.tabs_slider :deep(.swiper-wrapper) {
  height: auto;
  padding: 2px 2px;
  margin: 0 -2px;
}

.view_seat {
  display: flex;
  gap: 20px;
}
.view_seat .info_seat {
  width: 482px;
  height: 439px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 28px;
}
.view_seat .info_seat .data_view {
  color: #9299a0;
  font-size: 19px;
  line-height: 24px;
  margin-bottom: 4px;
}
.view_seat .info_seat .name_seat {
  color: var(--Blue-blue-700, #304da7);
  font-size: 28px;
  font-weight: 600;
  line-height: 24px; /* 85.714% */
  letter-spacing: -1.5px;
  margin-bottom: 24px;
}
.view_seat .info_seat .seat_desc {
  color: var(--Grey-grey-800, #505458);
  font-size: 22px;
  font-weight: 600;
  line-height: 24px;
}
.view_seat .info_seat .seat_desc.sub {
  font-weight: 400;
}
.view_seat .info_seat .list_info {
  margin-top: 28px;
}
.view_seat .info_seat .list_info li {
  color: var(--Grey-grey-700, #686d72);
  display: flex;
  align-items: flex-start;
  font-size: 20px;
  line-height: 180%;
  letter-spacing: -0.4px;
}
.view_seat .info_seat .list_info li:before {
  position: relative;
  top: 2px;
  margin: 13px;
  display: inline-block;
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background-color: #b6bbbf;
  content: '';
}
.detail_image_list {
  position: relative;
  width: 420px;
  height: 90px;
}
.view_seat .tab_menu {
  position: static;
  border-radius: 7px;
  width: 100%;
  height: 100%;
  margin: 0;
}
.view_seat .tab_menu .swiper-slide {
  opacity: 0.6;
  width: 140px;
  height: 100%;
}
.view_seat .tab_menu .swiper-slide.active {
  opacity: 1;
}
.view_seat .tab_menu .swiper-slide a img {
  width: 140px;
  height: 100%;
}
.view_seat .tab_menu .swiper-slide:last-child a img {
  border-radius: 0 7px 7px 0;
}
.view_seat .tab_menu .swiper-slide a {
  display: block;
  width: 100%;
  height: 100%;
}
.view_seat .tab_menu :deep(.swiper-button-prev),
.view_seat .tab_menu :deep(.swiper-button-next) {
  width: 30px;
  height: 30px;
  transform: translateY(-50%);
  margin: 0;
}
.view_seat .tab_menu :deep(.swiper-button-prev) {
  left: -15px;
}
.view_seat .tab_menu :deep(.swiper-button-next) {
  right: -15px;
}
.view_seat .tab_menu :deep(.swiper-button-prev:before),
.view_seat .tab_menu :deep(.swiper-button-next:before) {
  position: absolute;
  top: 0;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background-color: #fff;
  box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.2);
  content: '';
  flex: none;
}
.view_seat .tab_menu :deep(.swiper-button-prev:before) {
  left: 0;
}
.view_seat .tab_menu :deep(.swiper-button-next:before) {
  right: 5px;
  right: 0;
}
.view_seat .tab_menu :deep(.swiper-button-prev.swiper-button-disabled),
.view_seat .tab_menu :deep(.swiper-button-next.swiper-button-disabled) {
  display: none;
}
.view_seat .tab_menu :deep(.swiper-button-prev:after),
.view_seat .tab_menu :deep(.swiper-button-next:after) {
  color: #b6bbbf;
  font-weight: bold;
  font-size: 10px;
  z-index: 1;
}
.view_seat .tab_menu :deep(.swiper-button-prev:after) {
  margin-left: -2px;
}
.view_seat .tab_menu :deep(.swiper-button-next:after) {
  margin-right: -2px;
}
.view_seat .tab_content {
  flex: auto;
  height: 439px;
  overflow: hidden;
  border-radius: 16px;
}
.view_location {
  margin: 60px 0 0 0;
}
.view_location .local_image {
  overflow: auto;
  box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  width: 100%;
}
.view_location .label_location {
  margin-bottom: 24px;
  color: #505458;
  font-weight: 600;
  line-height: 24px;
  font-size: 22px;
}

@media (max-width: 767px) {
  .view_seat .tab_content {
    height: 234px;
    border-radius: 5px;
  }
  .view_seat {
    flex-direction: column;
    margin-top: 24px;
  }
  .view_seat .info_seat {
    width: 100%;
    height: auto;
    gap: 16px;
  }
  .view_seat .info_seat .name_seat {
    font-size: 22px;
    margin-bottom: 16px;
  }
  .view_seat .info_seat .seat_desc {
    font-size: 18px;
  }
  .view_seat .info_seat .list_info {
    margin-bottom: 8px;
  }
  .view_seat .info_seat .list_info li {
    font-size: 16px;
    line-height: 140%; /* 22.4px */
    letter-spacing: -0.32px;
  }
  .view_seat .info_seat .list_info li:before {
    margin-top: 6px;
  }
  .view_seat .info_seat .list_info li + li {
    margin-top: 8px;
  }
  .detail_image_list {
    width: 100%;
    height: auto;
    min-height: 70px;
  }
  .view_seat .tab_menu {
    width: unset;
  }
  .view_seat .tab_menu .swiper-slide {
    width: 33.333333% !important;
    height: unset;
  }
  .view_seat .tab_menu .swiper-slide a img {
    width: 100%;
    height: 100%;
  }
  .view_seat .tab_menu :deep(.swiper-button-prev),
  .view_seat .tab_menu :deep(.swiper-button-next) {
    display: none;
  }
  .view_location {
    margin: 20px 0 0 0;
  }
  .view_location .local_image img {
    width: auto;
    height: 190px;
  }
  .view_location .label_location {
    margin-bottom: 16px;
    font-size: 18px;
    line-height: 24px;
  }
  .tabs_slider {
    margin-bottom: 24px;
  }
  .tabs_slider :deep(.swiper-wrapper) {
    height: 41px;
  }
  .tabs_slider :deep(.swiper-button-next),
  .tabs_slider :deep(.swiper-button-prev) {
    display: none !important;
  }

  .tabs_slider .swiper-slide {
    margin-right: 8px;
  }
  .tabs_slider .swiper-slide a {
    font-size: 14px;
    padding: 0 12px;
    line-height: 39px;
  }
  .view_seat .info_seat .list_info .txt_info {
    font-size: 16px;
    line-height: 22px;
  }
}
</style>
